import { render, staticRenderFns } from "./JoinTextObjectDrawer.vue?vue&type=template&id=68b19eba&"
import script from "./JoinTextObjectDrawer.vue?vue&type=script&lang=ts&"
export * from "./JoinTextObjectDrawer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports